// (bnikom) code based off of https://github.com/emilebres/react-virtualized-checkbox
// differs from ./Checkboxes in that this is a functional component

import React, { Fragment } from 'react';
import { Input, Label } from 'reactstrap';
import { FixedSizeGrid as Grid } from 'react-window';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const CheckboxesNoClass = ({
  columnCount,
  columnWidth,
  height,
  items,
  rowHeight,
  width,
  labelKey,
  handleCheckboxClick,
  selectedItemArray
}) => {
  //  set the real height
  const modalEl = document.getElementById('featuredModal');
  const modalHeight = modalEl.offsetHeight;
  const realHeight = modalHeight - 240;

  const Checkbox = ({ checked, label, style, src, id, banned }) => (
    <div style={{ ...style }} className="px-2">
      <button
        className={`${checked ? 'border-green' : 'border'} w-100 p-2 bg-white`}
        type="button"
      >
        <div className="h-100">
          <p className="text-left">
            <Label check>
              <Input
                className="m-0 position-relative"
                type="checkbox"
                value={id}
                defaultChecked={selectedItemArray.indexOf(id) > -1}
                aria-label="Photo Checkbox"
                onClick={handleCheckboxClick}
              />
            </Label>
            &nbsp; Lot {label}
            {banned && (
              <span className="error-text"> (banned)</span>
            ) }
          </p>
          {checked && (
            <FontAwesomeIcon icon="check-circle" className="color-success check-photo" size="3x" />
          )}
          <div className="cover-photo-container d-flex justify-content-center align-items-center">
            <img
              className="mw-100 mh-100"
              src={src}
              alt={`Lot ${label}`}
            />
          </div>
        </div>
      </button>
    </div>
  );

  const checkboxRenderer = ({ columnIndex, rowIndex, style }) => {
    const index = columnIndex + columnCount * rowIndex;
    const item = items[index];

    return (
      <Fragment>
        {index <= items.length - 1 && (
          <Checkbox
            style={style}
            key={item[labelKey]}
            label={item[labelKey]}
            checked={item.checked}
            src={item.src}
            id={item.id}
            banned={item.banned}
          />
        )}
      </Fragment>
    );
  };

  return (
    <Grid
      columnCount={columnCount}
      columnWidth={columnWidth}
      height={realHeight}
      rowCount={Math.ceil((items.length + 1) / 4)}
      rowHeight={rowHeight}
      width={width}
    >
      {checkboxRenderer}
    </Grid>
  );
};

export default CheckboxesNoClass;
